var React = require('react');

function Subscribe (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"web/routes/subscribe"),React.createElement("g",{"fill":"#010202","key":1},[React.createElement("ellipse",{"cx":"68.27","cy":"431.268","rx":"68.27","ry":"68.268","key":0}),React.createElement("path",{"d":"M0 101.5c201.732 0 384.5 196.768 384.5 398.5h103C487.5 241.982 258.036 0 0 0v101.5z","key":1}),React.createElement("path",{"d":"M0 163.5V261c113.607 0 225 125.41 225 239h97.5C322.482 332.554 167.464 163.5 0 163.5z","key":2})])]);
}

Subscribe.defaultProps = {"width":"500","height":"500","viewBox":"0 0 500 500"};

module.exports = Subscribe;

Subscribe.default = Subscribe;
